<template>
  <div class="panel-container">
    <div class="left">
      <img :src="castImage" :alt="castName" class="left-img" />
    </div>
    <div class="right">
      <div v-if="isLinked" class="right-top">
        <Label class="right-top-linked">連携済み</Label>
      </div>
      <div class="right-middle">
        <div class="right-middle-name">{{ castName }}</div>
        <div v-if="quantity" class="right-middle-quantity">
          {{ quantity }}枚
        </div>
      </div>
      <div class="right-bottom">{{ date }} {{ part }}</div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '~/helpers/date'
import Label from '~/components/atoms/Label'
export default {
  components: {
    Label
  },
  props: {
    castName: {
      type: String,
      default: ''
    },
    quantity: {
      type: Number,
      default: undefined
    },
    castImage: {
      type: String,
      default: undefined
    },
    openTime: {
      type: String,
      default: undefined
    },
    closeTime: {
      type: String,
      default: undefined
    },
    part: {
      type: String,
      default: undefined
    },
    isLinked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    date() {
      return `${formatDate(this.openTime, 'M月D日 HH:mm')} ~ ${formatDate(
        this.closeTime,
        'HH:mm'
      )}`
    }
  }
}
</script>

<style scoped lang="scss">
.panel-container {
  display: flex;
}

.left {
  margin-right: 24px;
  &-img {
    width: 70px;
    height: 70px;
    border-radius: 5px;
    object-fit: contain;
  }
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;

  &-top {
    display: flex;
    justify-content: flex-end;
  }

  &-middle {
    display: flex;
    justify-content: space-between;

    &-name {
      font-size: 18px;
      font-weight: 600;
      margin-right: 8px;
    }

    &-quantity {
      font-weight: 600;
      width: 40px;
      min-width: 40px;
      display: inline-block;
    }
  }

  &-bottom {
    margin-right: 16px;
    font-size: 12px;
  }
}
</style>
